import { ChevronLeft, ChevronRight } from "lucide-react";

const PAGE_SIZES = [25, 50, 100];

export default function Pagination({ page, totalItems, pageSize, onPageChange, onPageSizeChange, sizes = PAGE_SIZES }) {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  const btnBase = {
    display: "flex", alignItems: "center", justifyContent: "center",
    width: 28, height: 28, borderRadius: 6, border: "1px solid #d1d5db",
    background: "#fff", cursor: "pointer", fontSize: 11, fontWeight: 600, color: "#475569",
  };
  const btnDisabled = { ...btnBase, opacity: 0.4, cursor: "default", pointerEvents: "none" };
  const btnActive = { ...btnBase, background: "#7c3aed", color: "#fff", border: "1px solid #7c3aed" };

  // Gera números de página com elipsis
  const getPages = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [];
    pages.push(1);
    if (page > 3) pages.push("...");
    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) {
      pages.push(i);
    }
    if (page < totalPages - 2) pages.push("...");
    pages.push(totalPages);
    return pages;
  };

  return (
    <div style={{
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "10px 16px", borderTop: "1px solid #e5e7eb", flexWrap: "wrap", gap: 8,
      fontSize: 11, color: "#64748b",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span>{totalItems} registro{totalItems !== 1 ? "s" : ""}</span>
        <span>•</span>
        <span>{start}–{end} de {totalItems}</span>
        <span>•</span>
        <select
          value={pageSize}
          onChange={(e) => { onPageSizeChange(Number(e.target.value)); onPageChange(1); }}
          style={{
            padding: "3px 6px", borderRadius: 5, border: "1px solid #d1d5db",
            fontSize: 11, background: "#fff", cursor: "pointer", fontFamily: "inherit",
          }}
        >
          {sizes.map((s) => <option key={s} value={s}>{s} por página</option>)}
        </select>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <button onClick={() => onPageChange(page - 1)} style={page <= 1 ? btnDisabled : btnBase}>
          <ChevronLeft size={14} />
        </button>
        {getPages().map((p, i) =>
          p === "..." ? (
            <span key={`e${i}`} style={{ padding: "0 4px", color: "#94a3b8" }}>…</span>
          ) : (
            <button key={p} onClick={() => onPageChange(p)} style={p === page ? btnActive : btnBase}>
              {p}
            </button>
          )
        )}
        <button onClick={() => onPageChange(page + 1)} style={page >= totalPages ? btnDisabled : btnBase}>
          <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
